import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import ComicSection from './components/ComicSection';
import WhyChooseUs from './components/WhyChooseUs';
import NewsletterCTA from './components/NewsletterCTA';
import { comics } from '@/mocks/comics';

const featuredComics = comics.filter((c) => c.featured);
const hotComics = comics.filter((c) => c.hot);
const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 6);

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '琉璃漫站',
  url: 'https://liulicomic.com',
  description: '琉璃漫站是专注于正版漫画在线阅读的综合平台，汇聚海量国漫、日漫、韩漫资源，提供高清流畅的阅读体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://liulicomic.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  useEffect(() => {
    document.title = '琉璃漫站 - 正版漫画在线阅读平台 | 国漫日漫韩漫';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '琉璃漫站是专注于正版漫画在线阅读的综合平台，汇聚海量国漫、日漫、韩漫资源，提供高清流畅的阅读体验。无论你是漫画新手还是资深漫迷，琉璃漫站都能满足你的追漫需求。');
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute('content', '琉璃漫站,琉璃漫站在线阅读,琉璃漫站正版漫画,琉璃漫站国漫推荐,琉璃漫站最新更新,琉璃漫站会员注册,漫画阅读平台推荐');
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <main>
        <HeroSection />
        <CategoryQuickLinks />
        <ComicSection
          title="编辑精选"
          subtitle="琉璃漫站编辑团队精心挑选的优质漫画"
          comics={featuredComics}
          viewMoreLink="/category/hot"
        />
        <ComicSection
          title="热门推荐"
          subtitle="大家都在看的热门漫画"
          comics={hotComics}
          viewMoreLink="/category/hot"
        />
        <ComicSection
          title="最新更新"
          subtitle="刚刚更新的章节，追更不迷路"
          comics={latestComics}
          viewMoreLink="/category/latest"
        />
        <WhyChooseUs />
        <NewsletterCTA />
      </main>
    </>
  );
}